import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJersey = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_755)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.5202 19.3066L14.2135 12H14.2135L21.5202 4.69331C21.205 4.28381 20.8603 3.88983 20.4853 3.51469C20.1101 3.13959 19.7162 2.79483 19.3066 2.47978L12 9.78642L12 9.78647L4.69331 2.47978C4.28386 2.79488 3.88983 3.13955 3.51469 3.51469C3.13955 3.88983 2.79483 4.28381 2.47978 4.69331L9.78642 11.9999L9.78647 12L2.47974 19.3067C2.79488 19.7162 3.1396 20.1102 3.51464 20.4853C3.88978 20.8604 4.28372 21.2052 4.69327 21.5202L12 14.2136L12 14.2135L19.3066 21.5202C19.7161 21.2051 20.1101 20.8604 20.4853 20.4853C20.8604 20.1101 21.2051 19.7161 21.5202 19.3066Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.91309 3.65217L12.0001 4.17389L14.087 3.65217V1.87828L13.2522 2.29566L12.0001 1.04348L10.7479 2.29566L9.91309 1.87828V3.65217Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.91309 3.65217V4.95661C9.91309 6.55411 12.0001 7.04358 12.0001 7.04358C12.0001 7.04358 14.087 6.55406 14.087 4.95661V3.65217H9.91309Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_755",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgJersey;
